export default __webpack_public_path__ + "static/media/withdraw-icon.25b882e7.webp";